// The user's categories (compass.categories), as every page names and groups by them.

// A category's name with its icon in front: "🏠 Home".
export const categoryLabel = (cat) => (cat.icon ? `${cat.icon} ${cat.label}` : cat.label);

// Items with no category, or one since deleted, group and filter together under this name.
export const NO_CATEGORY = "none";
export const NO_CATEGORY_LABEL = "No category";

// Whether an item (a goal or a task, by its own categoryId) is in the category `choice`, an id or NO_CATEGORY.
export const inCategory = (item, choice, categories) => {
  const known = (categories || []).some(c => c.id === item.categoryId);
  return choice === NO_CATEGORY ? !known : item.categoryId === choice;
};
